import React, { useState, useRef } from 'react'
import Parser from 'html-react-parser';
import { DscripSection, IconSection, Section, SectionImage, SectionText } from './StyledAboutUs'
import { Insta, Linked, face } from './images';
import { IconButton, Skeleton } from '@mui/material';
import { GET_REQUEST } from '../../../HooksApi/useApi';
import UseGetData from '../../../HookAxios/getdata';
import { Fade } from 'react-reveal';
const AbutUs = () => {

    const { isLoading: LoadAboutus, data: dataAboutus, isError: isErrorAboutus, error: errorAboutus, refetch: refetchAboutus }
        = GET_REQUEST({ queryKey: "aboutUs", request: () => UseGetData('about_us'), enabled: true })
    return (
        <Section>
            <SectionImage>
                {
                    !LoadAboutus && dataAboutus ? <>
                        <img src={`${process.env.REACT_APP_BASE_URL}${dataAboutus.data?.data.first_image_path}`} style={{ width: '32%', right: '10%', top: '20%', position: 'absolute', zIndex: 3, minWidth: '110px' }} alt="" />
                        <img src={`${process.env.REACT_APP_BASE_URL}${dataAboutus.data?.data.second_image_path}`} style={{ width: '42%', position: 'absolute', left: '30%', zIndex: 2, minWidth: '155px' }} alt="" />
                        <img src={`${process.env.REACT_APP_BASE_URL}${dataAboutus.data?.data.third_image_path}`} style={{ width: '30%', position: 'absolute', left: '10%', top: '20%', zIndex: 1, minWidth: '110px' }} alt="" />
                    </> : <>
                        <Skeleton style={{ width: '32%', right: '10%', top: '20%', position: 'absolute', zIndex: 3, minWidth: '110px', height: '30vh' }} />
                        <Skeleton style={{ width: '42%', position: 'absolute', left: '30%', zIndex: 2, minWidth: '155px', height: '50vh' }} />
                        <Skeleton style={{ width: '30%', position: 'absolute', left: '10%', top: '20%', zIndex: 1, minWidth: '110px', height: '30vh' }} />
                    </>
                }
            </SectionImage>
            <SectionText>
                {/* <HeaderSection>
                    {
                        dataAboutus?.data.data.title
                    }
                </HeaderSection> */}
                {
                    !LoadAboutus && dataAboutus ? <>
                        <DscripSection  >
                            {/* {dataAboutus.data.data?.brief} */}
                            {/* <RichTextEditor
                             value={htmlContent}
                            /> */}
                            {/* <Fade cascade > */}
                            {!LoadAboutus && Parser(dataAboutus.data.data?.brief)}
                            {/* </Fade> */}

                        </DscripSection>
                    </> :
                        <div style={{ width: '90%', marginTop: '15vh' }} >
                            <Skeleton style={{ width: '100%' }} />
                            <Skeleton style={{ width: '100%' }} />
                            <Skeleton style={{ width: '100%' }} />
                            <Skeleton style={{ width: '100%' }} />
                            <Skeleton style={{ width: '100%' }} />
                            <Skeleton style={{ width: '100%' }} />
                        </div>
                }
                {/* <IconSection>

                    <IconButton>
                        {
                            !LoadAboutus && dataAboutus ? <img src={face} alt="" /> : <Skeleton style={{ width: '20px', height: '20px', borderRadius: '50%' }} />
                        }
                    </IconButton>
                    <IconButton>
                        {
                            !LoadAboutus && dataAboutus ? <img src={Linked} alt="" /> : <Skeleton style={{ width: '20px', height: '20px', borderRadius: '50%' }} />
                        }
                    </IconButton>
                    <IconButton>
                        {
                            !LoadAboutus && dataAboutus ? <img src={Insta} alt="" /> : <Skeleton style={{ width: '20px', height: '20px', borderRadius: '50%' }} />
                        }
                    </IconButton>
                </IconSection> */}

            </SectionText>
        </Section>
    )
}

export default AbutUs